import { useCallback } from 'react'
import useYam from '../bakery/useYam'
import { BigNumber } from 'bignumber.js'
import {  updateBidPrice } from '../../sushi/utils'
import { updateBidPrice as updateBidPrice2 } from '../../sushi/exchangeNFTs'

import { useActiveWeb3React } from '../'
import { userBidNFTContract } from '../../userType/userBidNFTContract'
import { MARKETTYPE, MARKETMULTITOKEN, MARKETTYPEV1, MARKETTYPEV3 } from '../../constants/bakery/nft'
import { userNftAddress } from '../../userType/userNftAddress'
import { userTokenAddress } from '../../userType/userTokenAddress'
import { multiTokenExchangeNftContract } from '../../userType/multiTokenExchangeNftContract'
import { userTokenDecimals } from '../../userType/userTokenDecimals'
import { userExchangeNFTContract } from '../../userType/userExchangeNFTContract'
import { userV3NFTContract } from '../../userType/userV3NFTContract'

const useUpdateBid = (tokenId: string, nftType?: string, onMaxBidPrice?: any, tokenName?: string) => {
  const {account} = useActiveWeb3React()
  const sushi = useYam()
  let exchangeNFTContract: any 
  let isMultiTokenNft = false

  if(nftType && MARKETTYPE.hasOwnProperty(nftType)){
    exchangeNFTContract = userBidNFTContract(sushi, nftType)
  }else if(nftType && MARKETMULTITOKEN.hasOwnProperty(nftType)){
    exchangeNFTContract = multiTokenExchangeNftContract(sushi, nftType)
    isMultiTokenNft = true
  }else if(nftType && MARKETTYPEV1.hasOwnProperty(nftType)){
    exchangeNFTContract = userExchangeNFTContract(sushi, nftType)
  }else if(nftType && MARKETTYPEV3.hasOwnProperty(nftType)){
    exchangeNFTContract = userV3NFTContract(sushi, nftType)
    isMultiTokenNft = true
  }
  const handleUpdate = useCallback(
    async (amount: string) => {
      console.log("---updateBidPrice---",updateBidPrice)
      try {
        let txHash
        if(!isMultiTokenNft){
          txHash = await updateBidPrice(
            exchangeNFTContract,
            tokenId,
            amount,
            account,
          )
        }else{
          let nftAddress = userNftAddress(sushi, nftType)
          let quoteAddress = userTokenAddress(sushi, tokenName)
          txHash = await updateBidPrice2(
            exchangeNFTContract,
            nftAddress,
            tokenId,
            quoteAddress,
            amount,
            account,
          )
        }


        let decimals = userTokenDecimals(tokenName)
        console.log("--onMaxBidPrice--",onMaxBidPrice)
        onMaxBidPrice && await onMaxBidPrice(new BigNumber(amount).div(new BigNumber(10).pow(decimals)).toString())
        console.log(txHash)
        return txHash
      } catch (error) {
        console.log("--error error--",error)

        return false
      }
    },
    [exchangeNFTContract, account, tokenId, onMaxBidPrice,isMultiTokenNft,nftType,sushi,tokenName]
  )

  return {onUpdate: handleUpdate}
}

export default useUpdateBid